package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.service.ui.allservice.AllServiceEvent
import com.essntl.features.service.ui.allservice.AllServiceNavigation
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.uikit.components.scroll.EsVerticalScrollbar
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import kotlin.collections.orEmpty

@Composable
fun ServicesGrid(
    state: AllServiceState,
    onEvent: (AllServiceEvent) -> Unit,
    onNavigation: (AllServiceNavigation) -> Unit,
    modifier: Modifier = Modifier,
    organisationServices: Boolean = false,
) {
    val gridState = rememberLazyGridState()

    Row(
        modifier = modifier
            .fillMaxWidth(),
    ) {
        LazyVerticalGrid(
            columns = GridCells.Adaptive(minSize = 200.dp),
            horizontalArrangement = Arrangement.spacedBy(10.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp),
            state = gridState,
            modifier = Modifier
                .padding(top = 1.spacing)
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(horizontal = 4.spacing, vertical = 3.spacing)
                .weight(1f)
                .fillMaxHeight(),
        ) {
            items(
                if (organisationServices)
                    state.getAllServiceOrganization.data
                        .orEmpty()
                        .distinctBy { it.id } else
                    state.getAllService.data,
                key = { it.id },
            ) { service ->
                val isSelected = rememberEquals(
                    service,
                    setOf(state.selectedServiceId),
                ) { s -> s.id }

                val category = rememberFind(
                    state.getAllCategory.data.orEmpty(),
                    service.category,
                ) { cat -> cat.id }

                ServiceItem(
                    service = service,
                    categoryIconUrl = category?.iconUrl,
                    onClick = { onNavigation(AllServiceNavigation.EditService(service.id)) },
                    isSelected = isSelected,
                    modifier = Modifier,
                )
            }

            if (!organisationServices) {
                if (state.getAllService.hasMore)
                    item(
                        key = "load-more",
                        span = {
                            GridItemSpan(maxLineSpan)
                        },
                    ) {
                        LoadMoreItems(
                            isLoading = state.getAllService.isLoading,
                            onLoadMore = {
                                onEvent(AllServiceEvent.LoadMoreServices)
                            },
                            modifier = Modifier
                                .weight(1f),
                        )
                    }
            }
        }

        EsVerticalScrollbar(
            lazyGridState = gridState,
            modifier = Modifier
                .fillMaxHeight(),
        )
    }
}